import ParentService from '@services/GeniebookAPI/ParentServices.services';
import { useQuery } from '@tanstack/react-query';

export const useStudentSubjectMenuList = (is_parent = true) => {
  return useQuery({
    queryKey: ['parent_student_subject_menu_list'],
    queryFn: ParentService.student_subject_menu_list,
    staleTime: 60000,
    enabled: is_parent,
  });
};
